import { ParticipantsRoleAssignmentApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useParticipantsRoleAssignmentApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(
    () => new ParticipantsRoleAssignmentApi(configuration),
    [configuration]
  );
};
